<template>
  <div
    :class="[
      bem.b(),
      prepareClassNames(),
      bem.is('open', open),
      bem.is('fold', isShowFoldBtn),
    ]"
    :style="{
      ...prepareStyles(),
    }"
  >
    <el-form ref="elFormRef" :model="formData" v-bind="customAttrs">
      <slot>
        <el-row>
          <el-col
            v-for="(item, index) in filterFormItemList"
            v-show="isShowFormItem(index)"
            :key="item.prop || index"
            :class="bem.e('col')"
            :span="item.col || 24 / col"
          >
            <FormItem
              :form-data="formData"
              :form-label-width="labelWidth"
              v-bind="item"
              @registerFormItemRenderRef="
                (ref) => registerFormItemRenderRef(item.props?.ref, ref)
              "
            />
          </el-col>
        </el-row>
      </slot>
    </el-form>
    <div v-if="isShowFoldBtn" :class="bem.e('fold')" @click="toggleStatus">
      {{ open ? t('ep.form.collapse') : t('ep.form.more') }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, reactive, ref, useTemplateRef } from 'vue'
import { createNameSpace } from '@el-plus/utils/bem'
import {
  formProps,
  formEmits,
  formEmitsKeys,
  expandFormPropsKeys,
} from './form'
import type { FormEmits } from './form'
import {
  prepareProps,
  prepareEvents,
  prepareClassNames,
  prepareStyles,
} from '@el-plus/utils/props'
import { ElForm, ElRow, ElCol } from 'element-plus'
import { useCollapse, useForm } from './hooks/use-form'
import FormItem from './form-item-vue'
import { useLocale } from '@el-plus/hooks/use-locale'
const { t } = useLocale()
defineOptions({
  name: 'EpForm',
  inheritAttrs: false,
})
const bem = createNameSpace('form')
const props = defineProps(formProps)
const emit = defineEmits(formEmits)
const customAttrs = computed(() => {
  return {
    ...prepareProps(props, ['modelValue', 'model', ...expandFormPropsKeys]),
    hideRequiredAsterisk: true, // 隐藏必填星号, 使用自己的*
    scrollToError: true,
    ...prepareEvents<FormEmits>(emit, formEmitsKeys),
  }
})
const formData = defineModel<Record<string, unknown>>({
  default: () => reactive({}),
})

const {
  filterFormItemList,
  elFormRef,
  validate,
  resetFields,
  clearValidate,
  getFormItemRenderRef,
  registerFormItemRenderRef,
} = useForm(props)

const { open, toggleStatus, isShowFoldBtn, isShowFormItem } = useCollapse(
  {
    filterFormItemList,
    isShowFold: props.isShowFold,
    showFieldCount: props.showFieldCount,
  },
  emit,
)

defineExpose({
  elFormRef,
  validate,
  resetFields,
  clearValidate,
  getFormItemRenderRef
})
</script>
